(function () {
    'use strict';

    function shareWithPartnersController($log, $q, $scope, $timeout, searchDataService) {

        var vm = this;
        vm.searchFormTitle = '';
        vm.selectedSharingPartners = [];
        vm.projectEntityId = null;
        $scope.init = function(extension, projectEntityId, projectId) {
            vm.queryModel.predicates["EntityType"].value = extension.EntityTypes.join(',');
            vm.searchFormTitle = extension.prompt;
            vm.selectedSharingPartners = extension.ProjectSharingConnections;
            vm.projectEntityId = projectEntityId;
            vm.projectId = projectId;
            $log.debug('init');
        }
        vm.partners = [];
        vm.totalItems = 0;
        vm.orderBy = function orderBy(field) {
            if (vm.queryModel.orderBy === field) {
                if (vm.queryModel.orderByDirection == 'asc') {
                    vm.queryModel.orderByDirection = 'desc';
                } else {
                    vm.queryModel.orderByDirection = 'asc';
                }
            } else {
                vm.queryModel.orderBy = field;
                vm.queryModel.orderByDirection = 'asc';
            }
        };

        vm.queryModel = {
            uri: '[BuildifyApiHost]/api/platformentities',
            pageSize: 5,
            pageNum: 0,
            numPages: 0,
            orderBy: "Name",
            orderByDirection: "asc",
            predicates:
            {
                "EntityType": {
                    condition: "In",
                    dynamicField: true,
                    watch: function () { return true; }
                },
                "Name": {
                    condition: "StartsWith",
                    value: '',
                    dynamicField: true,
                    watch: function () {
                        $log.debug(vm.queryModel.predicates['Name'].value);
                        return true;
                    }
                }
            },
            injectedPredicates: []
        };

        vm.togglePartnerSelection = function (entity, projectSharingConnections) {
            var existingEntityIds = projectSharingConnections.map(function (item) {
                return item.EntityId;
            });
            var indexOfEntityToAdd = existingEntityIds.indexOf(entity.EntityId);
            if (indexOfEntityToAdd !== -1) {
                projectSharingConnections.splice(indexOfEntityToAdd, 1);
                entity.isSelected = false;
            } else {
                projectSharingConnections.push({
                    EntityId: entity.EntityId,
                    Status: 'Active',
                    LastActivityDate: new Date(),
                    Entity: entity
                });
                entity.isSelected = true;
            }
        }

        $scope.$watch(function () { return vm.queryModel; },
            function () {
                if (vm.queryModel.predicates["EntityType"].value) {
                    getPartners(vm.queryModel);
                }
            }, true);

        function getPartners() {
            var extraParameters  = [{ name: 'projectId', value: vm.projectId }];
            searchDataService.getResults(vm.queryModel, extraParameters).then(querySucceeded);
        }

        function querySucceeded(data) {
            vm.totalItems = data.TotalResults;
            vm.partners = data.Results.filter(function(partner) {
                if (vm.selectedSharingPartners.some(function(selectedPartner) {
                    return partner.EntityId === selectedPartner.EntityId;
                })) {
                    vm.totalItems--;
                    return false;
                }
                else if (partner.EntityId === vm.projectEntityId) {
                    vm.totalItems--;
                    return false;
                }

                return true;
            });
        }
    }

    shareWithPartnersController.$inject = ['$log', '$q', '$scope', '$timeout', 'searchDataService'];

    angular.module('ecap.workflow').controller('shareWithPartnersController', shareWithPartnersController);
})();